import { parseWhatsAppFormatting, type ChatInlineRun } from '@zrsystem/utils';
import { type ReactElement, type ReactNode } from 'react';

import './formatted-chat-text.css';

function renderRuns(runs: readonly ChatInlineRun[]): ReactNode {
  return runs.map((run, index) => {
    let node: ReactNode = run.value;
    if (run.mono) node = <code key={`m-${index}`}>{node}</code>;
    if (run.strike) node = <s key={`s-${index}`}>{node}</s>;
    if (run.italic) node = <em key={`i-${index}`}>{node}</em>;
    if (run.bold) node = <strong key={`b-${index}`}>{node}</strong>;
    return <span key={index}>{node}</span>;
  });
}

export function FormattedChatText({ text }: { readonly text: string }): ReactElement {
  const blocks = parseWhatsAppFormatting(text);
  return (
    <span className="formatted-chat-text">
      {blocks.map((block, index) => {
        if (block.kind === 'code') {
          return (
            <code key={index} className="formatted-chat-text__code">
              {block.value}
            </code>
          );
        }
        const body = renderRuns(block.runs);
        if (block.kind === 'quote') {
          return (
            <span key={index} className="formatted-chat-text__quote">
              {body}
              {'\n'}
            </span>
          );
        }
        if (block.kind === 'bullet') {
          return (
            <span key={index}>
              {'• '}
              {body}
              {'\n'}
            </span>
          );
        }
        if (block.kind === 'numbered') {
          return (
            <span key={index}>
              {block.index}. {body}
              {'\n'}
            </span>
          );
        }
        return (
          <span key={index}>
            {body}
            {index < blocks.length - 1 ? '\n' : null}
          </span>
        );
      })}
    </span>
  );
}
